// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"204a4f4a","142":"8ae8cc37","574":"d4d6a100","784":"c49f6303","825":"31b6ecd0","883":"a7d3638d","910":"a2b217c1"}[chunkId] + ".chunk.js";
};